export class BexApiNoPropertiesFoundError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, BexApiNoPropertiesFoundError.prototype);
  }
}
